import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { PopupModalComponent } from 'app/shared/popup-modal/popup-modal.component';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
@Component({
  selector: 'app-enrolment-view',
  templateUrl: './enrolment-view.component.html',
  styleUrls: ['./enrolment-view.component.scss','../../../../../../assets/sass/pages/page-users.scss']
})
export class EnrolmentViewComponent implements OnInit {
  enrolmentId:any
  enrolData:any
  transactionData=[]
  userId:any;
  enrollId:any
  studentId:any
  studentsData:any
  user_role:any
  user_type:any
  empType:any

  project_list =[]
  selected_project=null
  project_cat_id = "644a5c10af0db342c32eeada"
  constructor(private apiService:ApiService,private activatedroute:ActivatedRoute,
    private modalService: NgbModal,
    private route: Router, public toastr: ToastrService,    ) { 
    this.user_role=JSON.parse(localStorage.getItem('user'))
    if(this.user_role.roles !=='admin'){
      this.empType = this.user_role.employeetype.map(item=>item.displayname)
      if(this.empType.includes('Management') || this.empType.includes('HR')){
        this.activatedroute.paramMap.subscribe(params => { 
          this.enrolmentId = params.get('id'); 
      });
      }
    }
    if(this.user_role.roles ==='admin'){
      this.activatedroute.paramMap.subscribe(params => { 
        this.enrolmentId = params.get('id'); 
    });
    }
    else{
      window.history.back()
    }
    

  }

  ngOnInit(): void {
    if(this.user_role.roles ==='admin'){
      this.getEnrolById();
      this.getProjectCategory()
    }
    if(this.user_role.roles !=='admin'){
      if(this.empType.includes('Management') || this.empType.includes('HR')){
        this.getEnrolById();
        this.getProjectCategory()
      }
    }

  }
  getEnrolById(){
    this.apiService.getEnrolmentById(this.enrolmentId).subscribe((res:any)=>{
      this.enrolData=res.data[0]
      this.userId=this.enrolData?.user_id?._id
      if(this.userId){
        this.getTransactionByUser(this.enrolmentId)
        this.getStudentById(this.userId)

      }
    })
  }
  getTransactionByUser(id){
    this.apiService.getTransactionByEnrollId(id).subscribe((res:any)=>{
      this.transactionData=res.data
    })
  }
  back(){
    this.route.navigate(['enrollments/enrollment-list'])
  }
  openContentAddFee(id:any) {
    this.enrollId=id
    const modalRef = this.modalService.open(PopupModalComponent);
    modalRef.componentInstance.enrollId = this.enrollId
    modalRef.result.then((data) => {
        this.getTransactionByUser(this.enrollId)
    }, (reason) => {
      // on dismiss
    });
  
  }
  openContent(id:any,transaction_Id:any) {
    let enrol_Id=id
    let transaction_id=transaction_Id
    const modalRef = this.modalService.open(PopupModalComponent);
    modalRef.componentInstance.enrol_Id = enrol_Id;
    modalRef.componentInstance.transaction_id = transaction_id;
    modalRef.result.then((data) => {
      if(data == 'success'){
        this.getTransactionByUser(enrol_Id)
      }
    }, (reason) => {
      // on dismiss
 });
}
deleteTransaction(id){
  swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to Delete Transaction!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#2F8BE6',
    cancelButtonColor: '#F55252',
    confirmButtonText: 'OK',
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-danger ml-1'
    },
    buttonsStyling: false,
  }).then( (result)=> {
    if (result.value) {
      this.apiService.deleteTransaction(id).subscribe((res:any)=>{
          if (res.isSuccess === true) {
            swal.fire({
              icon: "success",
              title: 'Deleted!',
              text: 'Your transaction has been deleted.',
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
            this. getTransactionByUser(this.enrolmentId)
          }
          else{
            this.toastr.error(res.error)
          }
     
    })
  }
});
  // this.apiService.deleteTransaction(id).subscribe((res:any)=>{
  //   if (res.isSuccess === true) {
  //     console.log('del res',res)
  //     this.toastr.success(res.message)
  //     this. getTransactionByUser()
  //   }
  //   else{
  //     this.toastr.error(res.error)
  //   }
  // })
}

getStudentById(id:any){
    this.apiService.getStudentById(id).subscribe((res:any)=>{
    this.studentsData=res?.data
    })

}
getProjectCategory(){
    this.apiService.getTagByTagCatgoryId(this.project_cat_id).subscribe((res: any) => {
      let data = res?.data?.filter(item => item.name ==='project')
      this.getAllProject(data[0]?._id)
    })
}
getAllProject(id){
  this.apiService.getJobByWorkOn(id,1,100).subscribe((res:any)=>{
    this.project_list = res?.data?.items
  })
}
getProjectId(event){
  this.selected_project
}
openContentProjectAssign(content,id,project_id) {
  this.enrollId = id
  if(project_id){
    this.selected_project = project_id
  }
  const options: NgbModalOptions = {
    size: 'md', // set the size of the modal
    backdrop: 'static', // set whether clicking outside the modal closes it
    centered: true // set whether the modal is centered vertically
  };
  
  const modalRef = this.modalService.open(content,options);

  modalRef.result.then((result) => {
    this.enrollId = null
  }, (reason) => {
    this.enrollId = null
  });
}

projectAssign(){
  let body ={
    project_assign : this.selected_project
  }
  this.apiService.updateEnrolment(this.enrollId,body).subscribe((res:any)=>{
    if(res?.statusCode === 200){
      this.toastr.success('project assigned successfull!')
      this.modalService.dismissAll()
      this.getEnrolById();
    }
    else this.toastr.error(res?.error)
  })
}
setToEmp(id){
  this.apiService.changeRole(id).subscribe((res:any)=>{
    if(res?.statusCode ===200){
      this.toastr.success(res?.message)
    }
    else this.toastr.error(res?.error)
  })
}
}
